export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  UPDATE_PASSWORD: '/update-password',
  RESET_PASSWORD: '/reset-password',
  PROFILE: '/profile',
  TERMS_AND_CONDITIONS: '/terms-and-conditions'
};

export const ERROR_CODES = {
  INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
  LIMIT_EXCEEDED: 'LIMIT_EXCEEDED'
};

export const TERMS_AND_CONDITONS_URL =
  'https://ru.boss.az/terms-and-conditions ';

export const STORAGE_KEYS = {
  THEME: 'theme',
  LOCKOUT_END: 'lockout_end'
};
